import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';

var linearProgressThemeWeb = {
  color: 'primary',
  height: 8,
  borders: {
    radius: 0
  },
  bar: {
    inactiveColor: colors.fogGrey
  }
};
var linearProgressDarkThemeWeb = _extends({}, linearProgressThemeWeb, {
  bar: _extends({}, linearProgressThemeWeb.bar, {
    inactiveColor: colors.octoberGrey
  })
});

export { linearProgressDarkThemeWeb, linearProgressThemeWeb };
